<template>
  <v-dialog v-model="visible" max-width="600px" persistent>
    <v-card class="mb-0">
      <v-card-title class="headline">
        <v-icon left>{{ iconoDeporte }}</v-icon>
        {{ tituloModal }}
        <v-spacer></v-spacer>
        <v-tooltip bottom v-if="esFutbol">
          <template v-slot:activator="{ on }">
            <v-btn
              icon
              large
              color="indigo"
              @click="inscripciones"
              v-on="on"
              class="ml-1"
            >
              <v-icon large>mdi-format-list-numbered</v-icon>
            </v-btn>
          </template>
          <span>Lista de Inscriptos</span>
        </v-tooltip>
      </v-card-title>

      <v-card-subtitle v-if="partido">
        <v-row class="mt-6">
          <v-col cols="5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  color="primary"
                  class="nombre-equipo"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ partido.local?.nombre }}
                </v-chip>
              </template>
              <span>{{ partido.local?.nombre }}</span>
            </v-tooltip>
          </v-col>
          <v-col cols="2">
            <strong>VS</strong>
          </v-col>
          <v-col cols="5">
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-chip
                  color="secondary"
                  class="nombre-equipo"
                  v-bind="attrs"
                  v-on="on"
                >
                  {{ partido.visitante?.nombre }}
                </v-chip>
              </template>
              <span>{{ partido.visitante?.nombre }}</span>
            </v-tooltip>
          </v-col>
        </v-row>
      </v-card-subtitle>

      <v-card-text>
        <!-- FÚTBOL: Solo un partido con goles -->
        <v-form v-if="esFutbol" @submit.prevent ref="form">
          <v-row class="mb-3">
            <v-col cols="12">
              <h4 class="subtitle-1">Resultado del Partido</h4>
            </v-col>
            <v-col cols="5">
              <v-text-field
                v-model.number="resultadoFutbol.golesLocal"
                label="Goles Local"
                min="0"
                maxlength="2"
                outlined
                dense
                prepend-inner-icon="mdi-soccer"
                @keypress="onlyNumber"
                @input="actualizarSelectoresGoleadores('local')"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="text-center pt-6">
              <strong>-</strong>
            </v-col>
            <v-col cols="5">
              <v-text-field
                v-model.number="resultadoFutbol.golesVisitante"
                label="Goles Visitante"
                min="0"
                maxlength="2"
                outlined
                dense
                prepend-inner-icon="mdi-soccer"
                @keypress="onlyNumber"
                @input="actualizarSelectoresGoleadores('visitante')"
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- SELECTORES DE GOLEADORES - LOCAL -->
          <v-row v-if="resultadoFutbol.golesLocal > 0" class="mt-4 goleadores">
            <v-col cols="12">
              <h4 class="subtitle-1 mb-2">
                <v-icon small class="mr-2" color="primary"
                  >mdi-account-star</v-icon
                >
                Goleadores {{ partido.local?.nombre }}
              </h4>
            </v-col>
            <v-col
              cols="12"
              v-for="(gol, index) in goleadoresLocal"
              :key="`local-${index}`"
              class="py-2"
            >
              <v-autocomplete
                v-model="gol.idJugador"
                :items="jugadoresLocal"
                item-text="nombreJugador"
                item-value="idJugador"
                :label="`Gol ${index + 1}`"
                dense
                outlined
                clearable
                prepend-inner-icon="mdi-soccer"
                :no-data-text="'No hay jugadores inscriptos para el equipo'"
                chips
                return-object
              >
                <template v-slot:selection="{ item }">
                  <v-chip small color="primary" text-color="white">
                    {{ item.nombreJugador }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <!-- SELECTORES DE GOLEADORES - VISITANTE -->
          <v-row
            v-if="resultadoFutbol.golesVisitante > 0"
            class="mt-4 goleadores"
          >
            <v-col cols="12">
              <h4 class="subtitle-1 mb-2">
                <v-icon small class="mr-2" color="secondary"
                  >mdi-account-star</v-icon
                >
                Goleadores {{ partido.visitante?.nombre }}
              </h4>
            </v-col>
            <v-col
              cols="12"
              v-for="(gol, index) in goleadoresVisitante"
              :key="`visitante-${index}`"
              class="py-2"
            >
              <v-autocomplete
                v-model="gol.idJugador"
                :items="jugadoresVisitante"
                item-text="nombreJugador"
                item-value="idJugador"
                :label="`Gol ${index + 1}`"
                dense
                outlined
                clearable
                prepend-inner-icon="mdi-soccer"
                :no-data-text="'No hay jugadores inscriptos para el equipo'"
                chips
                return-object
              >
                <template v-slot:selection="{ item }">
                  <v-chip small color="secondary" text-color="white">
                    {{ item.nombreJugador }}
                  </v-chip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>

          <v-alert v-if="!formValidoFutbol" type="warning" dense class="mt-4">
            Debe ingresar los goles de ambos equipos
          </v-alert>
        </v-form>

        <!-- TENIS/PADEL: Sets con games -->
        <v-form v-else @submit.prevent ref="form">
          <v-row v-for="(set, index) in sets" :key="index" class="mb-3">
            <v-col cols="12">
              <h4 class="subtitle-1">Set {{ index + 1 }}</h4>
            </v-col>
            <v-col cols="5">
              <v-text-field
                v-model.number="set.gamesLocal"
                type="number"
                label="Games Local"
                min="0"
                outlined
                dense
                :disabled="!!woGanador"
              ></v-text-field>
            </v-col>
            <v-col cols="2" class="text-center pt-6">
              <strong>-</strong>
            </v-col>
            <v-col cols="5">
              <v-text-field
                v-model.number="set.gamesVisitante"
                type="number"
                label="Games Visitante"
                min="0"
                outlined
                dense
                :disabled="!!woGanador"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-alert v-if="sets.length < 1 && !woGanador" type="warning" dense>
            Se necesita al menos 1 set completo
          </v-alert>

          <!-- WO: el ganador gana 2pts, el perdedor 0pts -->
          <v-divider class="my-3"></v-divider>
          <v-row>
            <v-col cols="12">
              <div class="text-subtitle-2 mb-2">¿Partido ganado por W.O.?</div>
              <v-btn-toggle
                v-model="woGanador"
                dense
                column
                class="d-flex flex-column"
                style="gap: 6px"
              >
                <v-btn
                  value="local"
                  color="warning"
                  small
                  class="text-none justify-start"
                >
                  GANA
                  {{
                    partido && partido.local ? partido.local.nombre : "Local"
                  }}
                  por W.O.
                </v-btn>
                <v-btn
                  value="visitante"
                  color="warning"
                  small
                  class="text-none justify-start"
                >
                  GANA
                  {{
                    partido && partido.visitante
                      ? partido.visitante.nombre
                      : "Visitante"
                  }}
                  por W.O.
                </v-btn>
              </v-btn-toggle>
              <div v-if="woGanador" class="caption mt-1 orange--text">
                Resultado W.O.: 6-0 / 6-0. Ganador suma 2 pts, perdedor 0 pts.
              </div>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="cerrar" color="grey" dark>Cancelar</v-btn>
        <v-btn @click="guardar" color="success" :disabled="!formValido">
          Guardar Resultado
        </v-btn>
      </v-card-actions>
    </v-card>
    <lista-inscriptos
      :visible="modalInscripciones"
      :idTorneo="idTorneo"
      :infoTorneo="infoTorneo"
      :sistemaCompetencia="sistemaCompetencia"
      deporte="Futbol"
      :configuraciones="configuraciones"
      @close="cierraListaInscriptos"
    />
  </v-dialog>
</template>

<script lang="ts">
import { defineComponent, ref, computed, watch } from "vue";
import { showAlert } from "@/utils/toast";
import ListaInscriptos from "./ListaInscriptos.vue";
import axios from "@/axios-auth";

interface Goleador {
  idJugador: number | null;
  nombreJugador?: string;
}

interface Jugador {
  idJugador: number;
  nombreJugador: string;
}

export default defineComponent({
  name: "CargarResultado",

  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    partido: {
      type: Object,
      default: null,
    },
    proxy: {
      type: Object,
      default: null,
    },
    deporte: {
      type: String,
      default: "Padel", // 'Tenis', 'Padel', 'Futbol'
    },
    idTorneo: {
      type: [Number, String],
      required: true,
    },
    infoTorneo: {
      type: String,
    },
    sistemaCompetencia: {
      type: String,
      default: "Torneo",
    },
    configuraciones: {
      type: String,
    },
  },

  components: { ListaInscriptos },

  emits: ["close", "save"],

  setup(props, { emit }) {
    // Estado para tenis/padel
    const sets = ref([
      { gamesLocal: null, gamesVisitante: null },
      { gamesLocal: null, gamesVisitante: null },
      { gamesLocal: null, gamesVisitante: null },
    ]);

    const woGanador = ref<"local" | "visitante" | null>(null);

    // Estado para fútbol
    const resultadoFutbol = ref<{
      golesLocal: number | null;
      golesVisitante: number | null;
    }>({
      golesLocal: null,
      golesVisitante: null,
    });

    const modalInscripciones = ref(false);

    // Arrays de goleadores
    const goleadoresLocal = ref<Goleador[]>([]);
    const goleadoresVisitante = ref<Goleador[]>([]);

    // Arrays de jugadores disponibles
    const jugadoresLocal = ref<Jugador[]>([]);
    const jugadoresVisitante = ref<Jugador[]>([]);

    // Detectar si es fútbol
    const esFutbol = computed(() => {
      return props.deporte === "Futbol";
    });

    // Ícono según deporte
    const iconoDeporte = computed(() => {
      if (esFutbol.value) return "mdi-soccer";
      return "mdi-scoreboard";
    });

    // Título según deporte
    const tituloModal = computed(() => {
      if (esFutbol.value) return "Resultado del Partido";

      const esPartidoDeZona = props.partido && !props.partido.ronda;
      return esPartidoDeZona ? "Resultado de Zona" : "Resultado de Eliminación";
    });

    // Validación para fútbol
    const formValidoFutbol = computed(() => {
      return (
        Number.isInteger(resultadoFutbol.value.golesLocal) &&
        Number.isInteger(resultadoFutbol.value.golesVisitante) &&
        (resultadoFutbol.value?.golesLocal || 0) >= 0 &&
        (resultadoFutbol.value?.golesVisitante || 0) >= 0
      );
    });

    // Validación para tenis/padel
    const formValidoTenisPadel = computed(() => {
      // Si hay WO seleccionado, no se necesitan sets
      if (woGanador.value) return true;
      const setsCompletos = sets.value.filter(
        (s) =>
          Number.isInteger(s.gamesLocal) && Number.isInteger(s.gamesVisitante),
      );
      return setsCompletos.length >= 1; // permite partidos a 1 set
    });

    // Validación general
    const formValido = computed(() => {
      if (esFutbol.value) {
        return formValidoFutbol.value;
      }
      return formValidoTenisPadel.value;
    });

    const inscripciones = () => {
      modalInscripciones.value = true;
    };

    const cierraListaInscriptos = async () => {
      await cargarJugadoresEquipo(props.partido.local, true);
      await cargarJugadoresEquipo(props.partido.visitante, false);
      modalInscripciones.value = false;
    };

    // Cargar jugadores de un equipo específico
    const cargarJugadoresEquipo = async (equipo: any, esLocal: boolean) => {
      if (!equipo || !props.idTorneo) return;

      try {
        const { data = [] } = await axios.get("/Torneos/GetInscriptos", {
          params: {
            idTorneo: props.idTorneo,
          },
        });

        const jugadores = data || [];

        if (esLocal) {
          jugadoresLocal.value = jugadores.filter(
            (jugador: any) => jugador.equipo === equipo.nombre,
          );
        } else {
          jugadoresVisitante.value = jugadores.filter(
            (jugador: any) => jugador.equipo === equipo.nombre,
          );
        }
      } catch (error) {
        console.error("Error al cargar jugadores del equipo:", error);
        if (esLocal) {
          jugadoresLocal.value = [];
        } else {
          jugadoresVisitante.value = [];
        }
      }
    };

    // Actualizar selectores de goleadores según cantidad de goles
    const actualizarSelectoresGoleadores = (tipo: "local" | "visitante") => {
      const cantidadGoles =
        tipo === "local"
          ? resultadoFutbol.value.golesLocal || 0
          : resultadoFutbol.value.golesVisitante || 0;

      const goleadoresArray =
        tipo === "local" ? goleadoresLocal : goleadoresVisitante;

      const longitudActual = goleadoresArray.value.length;

      if (cantidadGoles > longitudActual) {
        // Agregar más selectores
        for (let i = longitudActual; i < cantidadGoles; i++) {
          goleadoresArray.value.push({ idJugador: null });
        }
      } else if (cantidadGoles < longitudActual) {
        // Remover selectores sobrantes
        goleadoresArray.value = goleadoresArray.value.slice(0, cantidadGoles);
      }
    };

    // Sincronizar datos cuando cambia el partido
    watch(
      () => props.partido,
      async (nuevoPartido) => {
        if (!nuevoPartido) return;

        if (esFutbol.value) {
          // Cargar jugadores de ambos equipos
          await cargarJugadoresEquipo(nuevoPartido.local, true);
          await cargarJugadoresEquipo(nuevoPartido.visitante, false);

          // Cargar resultado de fútbol existente
          if (nuevoPartido.resultado) {
            const partes = nuevoPartido.resultado.split("-");
            if (partes.length === 2) {
              resultadoFutbol.value.golesLocal = Number.isNaN(Number(partes[0]))
                ? null
                : Number(partes[0]);

              resultadoFutbol.value.golesVisitante = Number.isNaN(
                Number(partes[1]),
              )
                ? null
                : Number(partes[1]);
            }
          } else {
            resultadoFutbol.value.golesLocal = null;
            resultadoFutbol.value.golesVisitante = null;
          }

          // Cargar goleadores existentes si hay
          if (nuevoPartido.goleadores) {
            goleadoresLocal.value = nuevoPartido.goleadores.local || [];
            goleadoresVisitante.value = nuevoPartido.goleadores.visitante || [];
          } else {
            goleadoresLocal.value = [];
            goleadoresVisitante.value = [];
          }

          // Actualizar selectores según goles
          actualizarSelectoresGoleadores("local");
          actualizarSelectoresGoleadores("visitante");
        } else {
          // Cargar sets existentes (tenis/padel)
          if (nuevoPartido.sets && Array.isArray(nuevoPartido.sets)) {
            sets.value = nuevoPartido.sets.map((s: any) => ({
              gamesLocal: s.gamesLocal,
              gamesVisitante: s.gamesVisitante,
            }));

            while (sets.value.length < 3) {
              sets.value.push({ gamesLocal: null, gamesVisitante: null });
            }
          } else {
            sets.value = [
              { gamesLocal: null, gamesVisitante: null },
              { gamesLocal: null, gamesVisitante: null },
              { gamesLocal: null, gamesVisitante: null },
            ];
          }
          // Resetear WO al abrir
          woGanador.value = nuevoPartido.esWO
            ? nuevoPartido.ganador?.id === nuevoPartido.local?.id
              ? "local"
              : "visitante"
            : null;
        }
      },
      { immediate: true },
    );

    function onlyNumber($event: any) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    }

    const cerrar = () => {
      emit("close");
    };

    const guardar = () => {
      if (!formValido.value) {
        const mensaje = esFutbol.value
          ? "Por favor ingrese los goles de ambos equipos."
          : "Por favor complete al menos 2 sets con valores válidos.";

        showAlert({
          title: mensaje,
          timer: 4000,
          vm: props.proxy,
          icon: "warning",
        });
        return;
      }

      if (esFutbol.value) {
        // Guardar resultado de fútbol con goleadores
        const setsFutbol = [
          {
            gamesLocal: resultadoFutbol.value.golesLocal,
            gamesVisitante: resultadoFutbol.value.golesVisitante,
          },
        ];

        const goleadores = {
          local: goleadoresLocal.value.filter((g) => g.idJugador !== null),
          visitante: goleadoresVisitante.value.filter(
            (g) => g.idJugador !== null,
          ),
        };

        emit("save", setsFutbol, goleadores);
      } else {
        // WO: resultado fijo 6-0 / 6-0, ganador suma 2pts, perdedor 0pts
        if (woGanador.value) {
          const setsWO =
            woGanador.value === "local"
              ? [
                  { gamesLocal: 6, gamesVisitante: 0 },
                  { gamesLocal: 6, gamesVisitante: 0 },
                ]
              : [
                  { gamesLocal: 0, gamesVisitante: 6 },
                  { gamesLocal: 0, gamesVisitante: 6 },
                ];
          emit("save", setsWO, null, true); // tercer param = esWO
          return;
        }

        // Guardar sets de tenis/padel
        if (
          sets.value.some(
            (set) =>
              (set.gamesLocal && set.gamesLocal < 0) ||
              (set.gamesVisitante && set.gamesVisitante < 0),
          )
        ) {
          showAlert({
            title: "Los games no pueden ser números negativos.",
            timer: 4000,
            vm: props.proxy,
            icon: "warning",
          });
          return;
        }

        const setsParaGuardar = sets.value.filter(
          (s) =>
            Number.isInteger(s.gamesLocal) &&
            Number.isInteger(s.gamesVisitante),
        );

        emit("save", setsParaGuardar);
      }
    };

    return {
      sets,
      woGanador,
      resultadoFutbol,
      goleadoresLocal,
      goleadoresVisitante,
      jugadoresLocal,
      jugadoresVisitante,
      esFutbol,
      iconoDeporte,
      tituloModal,
      formValidoFutbol,
      formValidoTenisPadel,
      formValido,
      actualizarSelectoresGoleadores,
      cerrar,
      guardar,
      onlyNumber,
      inscripciones,
      cierraListaInscriptos,
      modalInscripciones,
    };
  },
});
</script>

<style scoped>
.nombre-equipo {
  span {
    margin-top: 12px;
    display: inline-block !important;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
.goleadores {
  max-height: 300px;
  overflow-y: auto;
}
</style>
